import { useFormikContext } from 'formik';
import { InputField, ErrorContainer, LabelComponent } from 'components';

interface TimeSpentProps {
  disabled: boolean;
}

export const TimeSpent = ({ disabled }: TimeSpentProps) => {
  const formik = useFormikContext<{
    timeSpentMin: number | null;
  }>();

  return (
    <>
      <LabelComponent mandatory text="Time spent (min)" />
      <InputField
        value={formik.values.timeSpentMin?.toString() ?? ''}
        onChange={(e) => {
          // only allow numbers
          if (e.target.value.match(/^[0-9]*$/)) {
            formik.handleChange(e);
          }
        }}
        onBlur={formik.handleBlur}
        name="timeSpentMin"
        disabled={disabled}
        placeholder="0"
        withGradient
      />
      <ErrorContainer
        visible={formik.touched.timeSpentMin && formik.errors.timeSpentMin}
        errors={formik.errors}
        name="timeSpentMin"
      />
    </>
  );
};
